import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import JobOpportunityCard from '@/components/seo/JobOpportunityCard';
import { JobTitleContext } from '@/context/create-context';
import { SimplifyJobDetailType } from '@/types/job-detail';
import { getHotJobOpportunities } from '@/api/tanzhi';

const Loading = () => {
  return (
    <div className="grid gap-6 grid-cols-4 grid-rows-3">
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
      <Skeleton height={130} variant="rounded" />
    </div>
  );
};

const HotJobOpportunity = ({ show }: { show: boolean }) => {
  const [loading, setLoading] = React.useState(true);
  const [hotJobs, setHotJobs] = React.useState<SimplifyJobDetailType[]>([]);
  const {
    jobTitle: { id, location },
  } = React.useContext(JobTitleContext);

  React.useEffect(() => {
    if (!id) return;
    getHotJobOpportunities({
      jobTitle: id,
      city: location?.pinyin || '',
      size: 12,
    })
      .then((res) => {
        if (res.status == 200) {
          setHotJobs(res.data);
        }
      })
      .finally(() => setLoading(false));
  }, [id, location]);

  return (
    <div className={`${show ? 'max-h-full' : 'max-h-0 overflow-hidden'}`}>
      <h3 className="text-xl font-semibold mb-8">热招职位</h3>
      {loading ? (
        <Loading />
      ) : (
        <div className="grid gap-6 grid-cols-4 tablet:grid-rows-3">
          {hotJobs.map((item, index) => (
            <JobOpportunityCard key={item.id + index} data={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default HotJobOpportunity;
